<wiz-vgroup padding="10px" width="100%" height="100%" class="section-container">
  <wiz-hgroup width="100%" height="100%">
    <wiz-vgroup width="100%" height="100%">
      <wiz-hgroup width="100%">
        <wiz-label
        [wizLabel]="'$.widget.configure.data-bank.$'"
        width="100%"
        class="smallTitleLabel"
        ></wiz-label>
        <wiz-icon (click)="hide()" style="cursor: pointer">close</wiz-icon>
      </wiz-hgroup>
      

      <wiz-list
      #lstFreeKeys
      width="100%"
      height="100%"
      [wizItemRenderer]="visionKeyRenderer"
    ></wiz-list>
    <filter-component #lstFreeKeysFilter width="100%"></filter-component>
    </wiz-vgroup>

  </wiz-hgroup>

  <wiz-hgroup width="100%">
    <wiz-dropdown #ddMaster
    [wizLabel]="'$.widget.master.$'"
    [wizDataProvider]="allAgis"
    [wizLabelField]="'labelAndIdx'"></wiz-dropdown>

    <wiz-checkbox #cbMefe [wizLabel]="'$.widget.slave.strictmode.$'" [visible]="hasMaster" [wizChecked]='emptyToEmpty'></wiz-checkbox>
  </wiz-hgroup>
  
  <wiz-hgroup width="100%">
    <wiz-dropdown #ddStep
    [wizLabel]="'$.widget.linkedStep.$'"
    [wizDataProvider]="stepDS"
    [wizLabelField]="'levelAndLabel'"></wiz-dropdown>
  </wiz-hgroup>

  <wiz-hgroup width="100%" horizontalAlign="end">
    <wiz-button wizLabel="$.common.validate.$" (wizClick)="save()" [wizDisabled]="!validable" width="200px"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
